export default __webpack_public_path__ + "static/media/gradient-avatar.12d84ab1.svg";